import auth from "./auth";
import casino from "./casino";
import profile from "./profile";
import tournament from "./tournament";
import landing from "./landing";
import info from "./info";
import pages from "./pages";
import promo from "./promo";
import newGlory from "./newGlory";
import fortuneWheel from "./fortuneWheel";

export default {
  auth,
  casino,
  pages,
  promo,
  profile,
  tournament,
  landing,
  info,
  newGlory,
  fortuneWheel,
};
